import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './marketing.css';
import { RouterProvider } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './api/queryClient';
import { BrandingProvider } from './contexts/BrandingContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { marketingRouter } from './router/marketing-routes';

const container = document.getElementById('root')!;

const app = (
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrandingProvider>
        <ThemeProvider>
          <AuthProvider>
            <RouterProvider router={marketingRouter} />
          </AuthProvider>
        </ThemeProvider>
      </BrandingProvider>
    </QueryClientProvider>
  </StrictMode>
);

if (container.children.length > 0) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}

document.body.classList.add('hydrated');
